import { handleDownloadOnClick } from "@_common/downloadfile";
import { formatText } from "@_common/format-text";
import { QueryRequestHelper } from "@_common/query-request-helper";
import CommonImportDataPopup from "@components/BulkUpload/ImportPopup";
import {
  downloadEntityMapping,
  downloadOnPremCheckpoint,
  importInterlinkedCheckpoint,
  importPECompliance,
  importSelfCompliance,
  importSelfComplianceBulkUpload,
  importVendorCheckpoint,
  uploadClientUser,
  uploadLegacyBulkImport,
  uploadLegacyBulkUpdateDocument,
  uploadLegacyBulkUpdateTask,
  uploadLegislation,
  uploadLegislationRule,
  uploadLicenseCheckpoint,
  uploadLicenseTaskUpdate,
  uploadLicenseUpdate,
  uploadReleaseDates,
  uploadSelfComplianceConfigBulkMapping,
  uploadSelfComplianceTaskBulkMapping,
  uploadStateCategoryOfLaw,
  uploadUserEntityMapping,
  uploadUserLocationMapping,
  uploadVendorCheckpointBulk,
  uploadVendors,
  uploadVendorsEmailLocationMapping,
  uploadVendorsHeadcount,
  uploadVendorsLocation,
  uploadVendorsUserLocationMapping,
  uploadVendorsUsers,
} from "@services/import.service";
import {
  importCheckpointConfigIC,
  importCheckpointIC,
  importEntityMappingIC,
} from "@services/internal-compliance.service";
import {
  complianceTaskImport,
  downloadLicenseTaskUpdateTemplate,
  licenseTaskImport,
} from "@services/license.service";
import { uploadFunctions, uploadLocations } from "@services/location.service";
import {
  getICCheckpointTemplates,
  getTemplates,
} from "@services/vendors.service";
import { getValue } from "@utils/lodash";
import { useState } from "react";
import { toast } from "react-toastify";

function ImportPopup(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const { isBulkUploadPopupVisible, setBulkuploadPopupVisibility } = props;
  const [isDataImported, setIsDataImported] = useState(false);
  const [response, setResponse] = useState({});
  const [importType, setImportType] = useState("");
  const [importedFile, setImportTedFile] = useState<any>(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const handleUpload = async () => {
    if (importedFile) {
      try {
        setSubmitLoading(true);
        let formData = new FormData();
        formData.append("file", importedFile);
        let resp;
        if (getValue(props, `type`, "")) {
          let commonFormData = new FormData();
          commonFormData.append("file", importedFile);
          if (getValue(props, `type`, "") === "INTERLINKED_CHECKPOINT") {
            resp = await importInterlinkedCheckpoint(commonFormData);
          }
          //---------------------- Checkpoint ----------------------//
          if (getValue(props, `type`, "") === "RELEASE_VENDOR_CHECKPOINT") {
            resp = await importVendorCheckpoint(commonFormData);
          }
          if (getValue(props, `type`, "") === "PE_COMPLIANCE") {
            resp = await importPECompliance(commonFormData);
          }
          if (getValue(props, `type`, "") === "SELF_COMPLIANCE_CONFIG") {
            resp = await importSelfCompliance(commonFormData);
          }
          if (
            getValue(props, `type`, "") === "SELF_COMPLIANCE_MASTER_BULK_UPLOAD"
          ) {
            resp = await importSelfComplianceBulkUpload(commonFormData);
          }
          //---------------------- Vendors --------------------------//
          if (getValue(props, `type`, "") === "VENDOR") {
            resp = await uploadVendors(commonFormData);
          }
          if (getValue(props, `type`, "") === "VENDOR_USER") {
            resp = await uploadVendorsUsers(commonFormData);
          }
          if (getValue(props, `type`, "") === "MAP_VENDOR_LOCATION") {
            resp = await uploadVendorsLocation(commonFormData);
          }
          if (getValue(props, `type`, "") === "VENDOR_HEADCOUNT") {
            resp = await uploadVendorsHeadcount(commonFormData);
          }
          if (getValue(props, `type`, "") === "LOCATION_MAPPING") {
            resp = await uploadVendorsUserLocationMapping(commonFormData);
          }
          if (getValue(props, `type`, "") === "MAP_VENDOR_LOCATION_EMAIL") {
            resp = await uploadVendorsEmailLocationMapping(commonFormData);
          }
          //---------------------- locations --------------------------//
          if (getValue(props, `type`, "") === "LOCATION") {
            resp = await uploadLocations(commonFormData);
          }
          if (getValue(props, `type`, "") === "FUNCTION") {
            resp = await uploadFunctions(commonFormData);
          }
          //---------------------- Task/Compliance ----------------------//
          if (getValue(props, `type`, "") === "COMPLIANCE_TASK") {
            resp = await complianceTaskImport(commonFormData);
          }
          //---------------------- Task/License -------------------------//
          if (getValue(props, `type`, "") === "LICENSES_TASK") {
            resp = await licenseTaskImport(commonFormData);
          }
          //---------------------- Entity Mapping -----------------------//
          if (getValue(props, `type`, "") === "ENTITY_MAPPING") {
            resp = await downloadEntityMapping(commonFormData);
          }
          //---------------------- On Prem / Checkpoint ------------------//

          if (getValue(props, `type`, "") === "CHECKPOINT") {
            resp = await downloadOnPremCheckpoint(commonFormData);
          }
          //---------------------- Legislation -----------------------//
          if (getValue(props, `type`, "") === "LEGISLATION") {
            resp = await uploadLegislation(commonFormData);
          }
          //---------------------- Legislation Rule -----------------------//
          if (getValue(props, `type`, "") === "LEGISLATION_RULE") {
            resp = await uploadLegislationRule(commonFormData);
          }
          //---------------------- State Category of Law -----------------------//

          if (getValue(props, `type`, "") === "STATE_CATEGORY_OF_LAW") {
            resp = await uploadStateCategoryOfLaw(commonFormData);
          }

          //---------------------- Client User -----------------------//
          if (getValue(props, `type`, "") === "CLIENT_USER") {
            resp = await uploadClientUser(commonFormData);
          }

          //---------------------- User Entity Mapping -----------------------//

          if (getValue(props, `type`, "") === "USER_ENTITY_MAPPING") {
            resp = await uploadUserEntityMapping(commonFormData);
          }

          //---------------------- Internal Compliance -----------------------//

          if (getValue(props, `type`, "") === "IC_CHECKPOINT") {
            resp = await importCheckpointIC(commonFormData);
          }
          if (getValue(props, `type`, "") === "IC_ENTITY_MAPPING") {
            resp = await importEntityMappingIC(commonFormData);
          }
          if (getValue(props, `type`, "") === "INTERNAL_COMPLIANCE") {
            resp = await importCheckpointConfigIC(commonFormData);
          }

          //---------------------- Release Dates -----------------------//
          if (getValue(props, `type`, "") === "RELEASE_DATES") {
            resp = await uploadReleaseDates(commonFormData);
          }

          //---------------------- User Location Mapping -----------------------//
          if (getValue(props, `type`, "") === "LOCATION_CLIENT_USER_MAPPING") {
            resp = await uploadUserLocationMapping(commonFormData);
          }

          //---------------------- SELF_COMPLIANCE_TASK_BULK_UPLOAD -----------------------//
          if (
            getValue(props, `type`, "") === "SELF_COMPLIANCE_TASK_BULK_UPLOAD"
          ) {
            resp = await uploadSelfComplianceTaskBulkMapping(commonFormData);
          }

          //---------------------- SELF_COMPLIANCE_CONFIG_BULK_UPLOAD -----------------------//
          if (
            getValue(props, `type`, "") === "SELF_COMPLIANCE_CONFIG_BULK_UPLOAD"
          ) {
            resp = await uploadSelfComplianceConfigBulkMapping(commonFormData);
          }

          //---------------------- User Location Mapping -----------------------//
          if (getValue(props, `type`, "") === "UPDATE_VENDOR_CHECKPOINT") {
            resp = await uploadVendorCheckpointBulk(commonFormData);
          }

          //---------------------- LEGACY_BULK_IMPORT -----------------------//
          if (getValue(props, `type`, "") === "LEGACY_BULK_IMPORT") {
            resp = await uploadLegacyBulkImport(commonFormData);
          }

          //---------------------- LEGACY_BULK_UPDATE_TASK -----------------------//
          if (getValue(props, `type`, "") === "LEGACY_BULK_UPDATE_TASK") {
            resp = await uploadLegacyBulkUpdateTask(commonFormData);
          }

          //---------------------- LEGACY_BULK_DOCUMENT -----------------------//
          if (getValue(props, `type`, "") === "LEGACY_BULK_DOCUMENT") {
            resp = await uploadLegacyBulkUpdateDocument(commonFormData);
          }

          //---------------------- LICENSE -----------------------//
          if (getValue(props, `type`, "") === "LOCATION_LICENSES_TASK") {
            resp = await uploadLicenseCheckpoint(commonFormData);
          }

          if (getValue(props, `type`, "") === "LOCATION_LICENSES_TASK_UPDATE") {
            resp = await uploadLicenseTaskUpdate(commonFormData);
          }
          if (getValue(props, `type`, "") === "LOCATION_LICENSES_UPDATE") {
            resp = await uploadLicenseUpdate(commonFormData);
          }
        } else {
          toast.error("Something went wrong, Please try after sometime");
        }
        if (resp) {
          setSubmitLoading(false);
          toast.success(getValue(resp, `message`, ""));
          setImportType("");
          setImportTedFile(null);
          importedSuccessfully();
          setResponse(getValue(resp, `data`, {}));
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please Upload File");
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeUpload = async (e: any) => {
    // setImportTedFile(e.target.files[0]);
    setImportTedFile(e[0]);
  };
  const closePopup = () => {
    setBulkuploadPopupVisibility(false);
    setIsDataImported(false);
    setImportTedFile("");
    props.setSelectedOption("");
  };
  const importedSuccessfully = () => {
    setIsDataImported(!isDataImported);
  };
  const handleDownload = async (type: string) => {
    try {
      setDownloadLoading(true);
      if (props.handleDownload) {
        await props.handleDownload(type);
        return;
      }
      if (props.onDownload) {
        await props.onDownload(type);
        return;
      }
      if (type === "LOCATION_LICENSES_TASK_UPDATE") {
        await downloadLicenseTaskUpdateTemplate();
        return;
      }
      if (type === "IC_CHECKPOINT") {
        let payload: any = {
          type: type,
        };
        let queryRequest = QueryRequestHelper(payload);
        try {
          let resp = await getICCheckpointTemplates(queryRequest);
          if (resp) {
            let URL = getValue(resp, `data.url`, "");
            let type = getValue(resp, `data.type`, "");
            if (URL) {
              handleDownloadOnClick(URL, formatText(type));
            }
          }
        } catch (error) { }
      } else {
        let payload: any = {
          type: type,
        };
        let queryRequest = QueryRequestHelper(payload);
        try {
          let resp = await getTemplates(queryRequest);
          if (resp) {
            let URL = getValue(resp, `data[${0}].url`, "");
            let type = getValue(resp, `data[${0}].type`, "");
            if (URL) {
              handleDownloadOnClick(URL, formatText(type));
            }
          }
        } catch (error) { }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <div>
      {isBulkUploadPopupVisible && (
        <CommonImportDataPopup
          handleUpload={handleUpload}
          handleChangeUpload={handleChangeUpload}
          closePopup={closePopup}
          isDataImported={isDataImported}
          setIsDataImported={setIsDataImported}
          importedSuccessfully={importedSuccessfully}
          importedFile={importedFile}
          setImportTedFile={setImportTedFile}
          response={response}
          handleDownload={handleDownload}
          submitLoading={submitLoading}
          downloadLoading={downloadLoading}
          url={props.url}
          type={props.type}
        />
      )}
    </div>
  );
}

export default ImportPopup;
